export default 'content-editor'
